export class EnhancedEcommerce {
  addProductImpressions(products: Array<object>): void {
    const impressions: Array<object> = [];

    window.dataLayer.push({
      'ecommerce': {
        'currencyCode': 'EUR',
        'impressions': impressions
      }
    });

    products.forEach((p, i) => {
      impressions.push({
        'name': p['name'],
        'id': p['product_id'],
        'price': p['final_price_incl_tax'],
        'brand': p['manufacturer'],
        'category': (p['category_names'] || []).join(' / '),
        'variant': '',
        'list': 'product-list',
        'position': (i + 1)
      });
    });
  }

  addProductClick(product: object, index: string | number): void {
    window.dataLayer.push({
      'event': 'productClick',
      'ecommerce': {
        'click': {
          'actionField': {'list': 'product-list'},
          'products': [{
            'name': product['name'],
            'id': product['product_id'],
            'price': product['final_price_incl_tax'],
            'brand': product['manufacturer'],
            'category': (product['category_names'] || []).join(' / '),
            'variant': '',
            'position': (index as number) + 1
          }]
        }
      }
    });
  }

  addProductDetail(product: object): void {
    window.dataLayer.push({
      'ecommerce': {
        'detail': {
          'products': [{
            'name': product['name'],
            'id': product['product_id'],
            'price': product['final_price_incl_tax'],
            'brand': product['manufacturer'],
            'category': (product['category_names'] || []).join(' / '),
            'variant': ''
          }]
        }
      }
    });
  }

  addProductAddToCart(product: object, qty: number = 1): void {
    window.dataLayer.push({
      'event': 'addToCart',
      'ecommerce': {
        'currencyCode': 'EUR',
        'add': {
          'products': [{
            'name': product['name'],
            'id': product['product_id'],
            'price': product['final_price_incl_tax'],
            'brand': product['manufacturer'],
            'category': (product['category_names'] || []).join(' / '),
            'variant': '',
            'quantity': qty
          }]
        }
      }
    });
  }

  addProductRemoveFromCart(product: object): void {
    window.dataLayer.push({
      'event': 'removeFromCart',
      'ecommerce': {
        'remove': {
          'products': [{
            'name': product['name'],
            'id': product['item_id'],
            'price': product['row_total_incl_tax'],
            'brand': '',
            'category': '',
            'variant': '',
            'quantity': product['qty']
          }]
        }
      }
    });
  }

  addCheckout(products: Array<object>, step: number, option: string = ''): void {
    const productList: Array<object> = [];

    if (step === 1) {
      window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': {'step': step, 'option': option},
            'products': productList
          }
        }
      });

      products.forEach(p => {
        productList.push({
          'name': p['name'],
          'id': p['item_id'],
          'price': p['row_total_incl_tax'],
          'brand': '',
          'category': '',
          'variant': '',
          'quantity': p['qty']
        });
      });
    } else {
      window.dataLayer.push({
        'event': 'checkoutOption',
        'ecommerce': {
          'checkout_option': {
            'actionField': {'step': step, 'option': option}
          }
        }
      });
    }
  }
}

const enhancedEcommerce = new EnhancedEcommerce();

export {enhancedEcommerce};
